export const ASSETS = {
  LOGO: "https://res.cloudinary.com/dfjdtufsq/image/upload/c_pad,b_auto:predominant,fl_preserve_transparency/v1667578168/samples/animals/my-logo_ckihba.jpg",
  PROFILE:
    "https://res.cloudinary.com/dicjyi6ic/image/upload/v1681192980/DSC_2079_1_ez7jfe.jpg",
};
